import React from "react";
import {TaxSubmission, TaxSubmissionRestControllerApiFactory} from "arteco-api-client-ts";
import {FormContent} from "../../../../components/form/form_inputs/form_buttons";
import {FormInput} from "../../../../components/form/form_inputs/form_input";
import {Grid} from "@mui/material";
import {useForm, UseFormProps} from "../../../../components/form/form_model";
import {useApiManager} from "../../../../components/utils/api";
import FormSelect from "../../../../components/form/form_inputs/form_select";
import {types} from "../../../../components/form/types";
import {useSearchParams} from "react-router-dom";

export const TaxSubmissionEditPage = () => {
    const apiManager = useApiManager();
    const ctrl = apiManager.factory(TaxSubmissionRestControllerApiFactory);
    // Desde Vencimientos (pantalla o correo) se llega con modelo, ejercicio y periodo en la URL:
    // se viene a marcarla como hecha, así que entra ya como presentada y con fecha de hoy.
    const [searchParams] = useSearchParams();

    const form = useForm({
        fetcher: (id) => ctrl.getTaxSubmission(id),
        updater: (bean) => ctrl.saveTaxSubmission(bean),
        remover: (id) => ctrl.deleteOrDismissTaxSubmission(id),
        factory: () => (searchParams.get("modelType") ? {
            modelType: searchParams.get("modelType"),
            year: Number(searchParams.get("year")),
            period: searchParams.get("period"),
            status: "PRESENTADO",
            presentationDate: new Date().toISOString().split("T")[0],
        } : {
            year: new Date().getFullYear(),
            status: "PENDIENTE",
        }) as unknown as TaxSubmission,
    } as UseFormProps<TaxSubmission>);

    return (
        <FormContent form={form} title={"Modelo fiscal"}>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <FormSelect
                        field={"modelType"}
                        label={"Modelo"}
                        type={types.taxModelTypes}
                    />
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormInput field={"year"} label={"Año"} type="number"/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormInput field={"period"} label={"Período (T1…T4, ANUAL, o M01…M12 en seguros sociales y nóminas)"}/>
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                    <FormInput field={"baseAmount"} label={"Base imponible"} type="number"/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormInput field={"taxAmount"} label={"Cuota"} type="number"/>
                </Grid>
                <Grid item xs={12} sm={4}>
                    <FormSelect
                        field={"status"}
                        label={"Estado"}
                        type={types.taxSubmissionStatuses}
                    />
                </Grid>
            </Grid>

            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"presentationDate"} label={"Fecha de presentación"} type="date"/>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormInput field={"reference"} label={"Referencia/CSV"}/>
                </Grid>
            </Grid>

            <FormInput field={"notes"} label={"Notas"} rows={3}/>
        </FormContent>
    );
};
